<template>
  <v-container fluid>
    <!-- <v-breadcrumbs :items="items">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs> -->
    <div id="app ">
      <div style="display: flex; justify-content: space-between;">
        <!-- <v-col cols="11"> -->
        <Breadcrumb class="row justify-content-center mt-4" />
        <!-- </v-col> -->
        <span v-if="showLoader">
          <LoaderProgress></LoaderProgress>
        </span>
      </div>
    </div>
    <v-data-table
      :headers="headersData"
      :items="usersData"
      :search="search"
      :mobile-breakpoint="0"
      :items-per-page="5"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on, attrs }">
              <!-- <v-btn class="" outlined fab small color="#0C479D">
                <v-icon>icon-download</v-icon>
              </v-btn> -->

              <v-btn
                :disabled="hideWhileLoading"
                class="mr-2 ml-4"
                small
                fab
                @click="addDoc()"
                color="#0C479D"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon class="icon-white">icon-add</v-icon>
              </v-btn>
            </template>
            <v-form ref="form">
              <v-card>
                <v-card-title class="background-blue">
                  <span class="text-h5 icon-white">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          label="UserName*"
                          v-model="editeditem.user_name"
                          required
                          :disabled="isEdit"
                          :rules="usernameRules"
                          prepend-icon="icon-user"
                        ></v-text-field>
                        <small
                          v-if="!isEdit && editeditem.user_name"
                          class="form-text text-muted"
                        >
                          <span v-if="usernameSearchInProgress"
                            >searching
                          </span>
                          <v-progress-circular
                            v-if="usernameSearchInProgress"
                            :size="20"
                            color="amber"
                            indeterminate
                          ></v-progress-circular>

                          <v-icon small color="green" v-if="usernameAvailable"
                            >mdi-check-circle</v-icon
                          >
                          <span v-if="usernameAvailable">available</span>
                          <v-icon small color="red" v-if="usernameNotAvailable"
                            >mdi-minus-circle-off</v-icon
                          >
                          <span v-if="usernameNotAvailable"
                            >{{ editeditem.user_name }} is not available</span
                          >
                        </small>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          label="First Name*"
                          v-model="editeditem.first_name"
                          required
                          :rules="rules"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          label="Last Name*"
                          v-model="editeditem.last_name"
                          required
                          :rules="rules"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          label="Email*"
                          v-model="editeditem.email"
                          prepend-icon="icon-email"
                          :rules="emailRules"
                          required
                        ></v-text-field>
                      </v-col>

                      <!-- phone number field -->

                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          label="phone Number"
                          v-model="editeditem.mobile"
                          required
                          prepend-icon="icon-phone"
                          :rules="mobilePhone"
                          type="number"
                          inputmode="numeric"
                        ></v-text-field>
                      </v-col>

                      <!-- phone number field -->

                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          label="Password"
                          :type="type"
                          prepend-icon="icon-lock"
                          v-model="editeditem.password"
                          :rules="isEdit ? '' : passwordRulesNew"
                        ></v-text-field>
                        <small
                          v-if="editeditem.password"
                          id="passwordHelp"
                          class="form-text text-muted"
                          >Password should contain
                          <span
                            :class="has_minimum_length ? 'has_required' : ''"
                            >atleast 8 characters</span
                          >,
                          <span :class="has_lowercase ? 'has_required' : ''"
                            >1 lowercase letter</span
                          >,
                          <span :class="has_uppercase ? 'has_required' : ''"
                            >1 Uppercase letter</span
                          >,
                          <span :class="has_number ? 'has_required' : ''"
                            >1 number</span
                          >,
                          <span :class="has_special ? 'has_required' : ''"
                            >1 special character.</span
                          >, and
                          <span :class="equalto_username ? 'has_required' : ''"
                            >Should not be same as User Name.</span
                          >
                        </small>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-select
                          label="Roles*"
                          :items="roleData"
                          item
                          prepend-icon="icon-role"
                          v-model="editeditem.roles"
                          item-text="role_name"
                          item-value="id"
                          required
                          multiple
                          :rules="selectedItemsRules"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-checkbox
                          v-model="checkbox"
                          @click="showPassword"
                          :label="btnText"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions class="pb-5">
                  <v-spacer></v-spacer>
                  <v-btn rounded color="#FE000C" @click="close">
                    <v-icon left class="icon-white">icon-cancel</v-icon>
                    <span style="color: white;">Cancel</span>
                  </v-btn>
                  <!-- <v-btn rounded color="primary" @click="save">
                  <v-icon left>icon-availability</v-icon>
                  Submit
                </v-btn> -->
                  <v-btn color="primary" @click="submitForm" rounded>
                    <v-icon left>icon-availability</v-icon>
                    Submit
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>

            <!-- changes -->
            <!-- <v-form ref="form">
    <v-text-field v-model="name1" :rules="nameRules1" label="Name" required></v-text-field>
    <v-text-field v-model="email1" :rules="emailRules1" label="Email" required></v-text-field>
    <v-btn color="primary" @click="submitForm">Submit</v-btn>
  </v-form> -->
            <!-- chnage -->
          </v-dialog>
        </v-toolbar>
      </template>
      
      <template v-slot:item.status="{ item }">
            <template v-if="item.status==true">
              <v-btn color="success"
               @click="deactivateAccess(item)"
               :disabled="disable">Deactivate</v-btn>
            </template>
            <template v-else>
              {{empty_status}}
            </template>

          </template>
      <!-- <template v-slot:item.status="{ item }">
        <v-switch color="success" v-model="item.active"></v-switch>
      </template>
      <template v-slot:item.isadmin="{ item }">
        <v-switch color="success" v-model="item.admin"></v-switch>
      </template> -->
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
          :disabled="hideWhileLoading"
        >
          icon-action
        </v-icon>
      </template>
      <template v-slot:item.active="{ item }">
        <v-switch
          :disabled="hideWhileLoading"
          color="indigo"
          @change="changeActiveStatus(item, item.active)"
          false-value="N"
          true-value="Y"
          v-model="item.active"
        ></v-switch>
      </template>
      <template v-slot:item.it_admin="{ item }">
        <v-switch
          color="indigo"
          @change="changeItAdminStatus(item, item.active)"
          v-model="item.it_admin"
        ></v-switch>
      </template>

      <template v-slot:item.admin="{ item }">
        <v-switch
          :disabled="hideWhileLoading"
          color="indigo"
          @change="changeAdminStatus(item, item.admin)"
          false-value="N"
          true-value="Y"
          v-model="item.admin"
        ></v-switch>
      </template>
      <!-- <template v-slot:no-data>
        <v-btn color="primary" @click="setGridData"> Reset </v-btn>
      </template> -->
    </v-data-table>
    <div id="sucessAlert">
      <v-alert outlined type="success" text> Data Saved successfully. </v-alert>
    </div>
    <div id="errorAlert">
      <v-alert outlined type="warning" prominent border="left">
        Error while saving the data.
      </v-alert>
    </div>
  </v-container>
</template>
<script>
import axios from "axios";
import Breadcrumb from "../components/breadcrumbs.vue";
import LoaderProgress from "../components/progressLoader";

// import constants from "../constants";
import router from "../router";
export default {
  components: { Breadcrumb, LoaderProgress },

  data: () => ({
    empty_status: '',
    // name: '',
    //   email1: '',
    //   password1: '',
    //   nameRules1: [
    //     v => !!v || 'Name is required',
    //     v => (v && v.length <= 50) || 'Name must be less than 50 characters',
    //   ],
    //   emailRules1: [
    //     v => !!v || 'E-mail is required',
    //     v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    //   ],
    //   passwordRules1: [
    //     v => !!v || 'Password is required',
    //     v => (v && v.length >= 8) || 'Password must be at least 8 characters',
    //   ],
    //chnages
    isEdit: false,
    showLoader: false,

    roleData: [],
    editedIndex: -1,
    search: "",
    headersData: [],
    usersData: [],
    dataDownload: [],
    dialog: false,
    btnText: "Show Password",

    checkbox: false,

    usernameSearchInProgress: false,
    usernameAvailable: false,
    usernameNotAvailable: false,
    passwordNotAllowed: false,
    passwordSearchInProgress: false,
    passwordAllowed: false,
    // menu: false,
    editeditem: {
      id: null,
      user_id: null,
      customer_name: "",
      user_name: "",
      email: "",
      first_name: "",
      last_name: "",
      password: "",
      roles: [],
      admin: "",
      active: "",
    },
    defaultItem: {
      customer_name: "",
      user_name: "",
      password: "",
    },
    items: [
      {
        text: "Home",
        disabled: false,
        href: "/",
      },
      {
        text: "Admin Menu",
        disabled: true,
        href: "/",
      },
      {
        text: "User Management",
        disabled: true,
      },
    ],

    type: "password",
    passwordRules: [
      (v) => !!v || "Password is required",
      (v) =>
        (v && v.length >= 8) || "Your password must be at least 8 characters",
    ],
    usernameRules: [
      (v) => !!v || "Username is required",
      (v) => (v && !/\s/.test(v)) || "Username must not contain any spaces",
    ],
    nameRules: [
      (v) => !!v || "Name is required",
      (v) =>
        (v && v.length <= 20) ||
        "Name must be less than or equals to 20 characters",
    ],
    selectedItemsRules: [
      (v) =>
        (Array.isArray(v) && v.length > 0) ||
        "You must select at least one item",
    ],
    // emailRules: [
    //   (v) =>
    //     !v ||
    //     /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    //       v
    //     ) ||
    //     "E-mail must be valid",
    // ],
    emailRules: [
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail must be valid",
    ],
    passwordRulesNew: [
      (v) => !!v || "Password is required",
      (v) =>
        (v && v.length >= 8) || "Password must be at least 8 characters long",
      (v) =>
        (v && /[A-Z]/.test(v)) ||
        "Password must contain at least one uppercase letter",
      (v) =>
        (v && /[a-z]/.test(v)) ||
        "Password must contain at least one lowercase letter",
      (v) =>
        (v && /[0-9]/.test(v)) || "Password must contain at least one number",
      (v) =>
        (v && /[^A-Za-z0-9]/.test(v)) ||
        "Password must contain at least one special character",
    ],
    mobilePhone: [
      (v) => !!v || "Phone number is required",
      (v) =>
        /^\d{10}$/.test(v) ||
        "Invalid phone number format (10 digits required)",
    ],
    hideWhileLoading: false,
    //password validation
    has_minimum_length: false,
    has_number: false,
    has_lowercase: false,
    has_uppercase: false,
    has_special: false,
    equalto_username: false,
    disable:false,
    dialogDelete: false,
    validEmail: false,
    rules: [(value) => !!value || "Required."],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add New User" : "Edit User";
    },
  },

  watch: {
    // "editeditem.password": function(val = 0) {
    //   console.log("checking password", val);
    //   this.has_minimum_length = this.editeditem.password.length > 8;
    //   console.log("chekcing has_minimum_length", this.has_minimum_length);
    //   /* eslint-disable-next-line */
    //   this.has_number = /\d/.test(this.editeditem.password);
    //   /* eslint-disable-next-line */
    //   this.has_lowercase = /[a-z]/.test(this.editeditem.password);
    //   /* eslint-disable-next-line */
    //   this.has_uppercase = /[A-Z]/.test(this.editeditem.password);
    //   /* eslint-disable-next-line */
    //   this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(
    //     this.editeditem.password
    //   );
    //   /* eslint-disable-next-line */
    //   this.equalto_username =
    //     this.editeditem.password !== this.editeditem.user_name;
    //   // if (val) {
    //   //   if (!this.passwordSearchInProgress) {
    //   //     setTimeout(() => {
    //   //       this.validatePassword();
    //   //     }, 2000);
    //   //   }
    //   // this.passwordSearchInProgress = true;
    //   // this.passwordAllowed = false;
    //   // this.passwordNotAllowed = false;
    //   // }
    // },
    "editeditem.email"() {
      this.validEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        this.editeditem.email
      );
    },
    "editeditem.user_name": function(val) {
      if (val) {
        if (!this.usernameSearchInProgress) {
          setTimeout(() => {
            this.searchUserName();
          }, 2000);
        }
        this.usernameSearchInProgress = true;
        this.usernameAvailable = false;
        this.usernameNotAvailable = false;
      }
    },

    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.setGridData();
  },

  methods: {
    deactivateAccess(item){
          this.disable=true
          this.showLoader = true;
          let config = {
            method: "post",
            url: `${this.$config.backend_url}/removeadminaccess`,
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
            data: item
          };
          this.noteLastAPICallTime();
          axios(config).then((response) => {
            try {
              if (response.data.status) {
                console.log("status true")
                this.disable=false
              } else {
                console.log("status false")
                this.disable=false
              }
              console.log("data-->>",response.data.data)
              this.getUsers()
              this.showLoader = false;
            } catch (error) {
              this.showLoader = false;
              console.log(error)
            }
    
          });
        },
    submitForm() {
      if (this.$refs.form.validate()) {
        // Form is valid, submit data
        this.save();
      } else {
        // Form is invalid, display error message
      }
    },
    //changes

    selected(crumb) {
      if (crumb === "Home") {
        router.push(`/${sessionStorage.getItem("route_first_option")}`);
      }
      console.log(crumb);
    },

    changeItAdminStatus(item) {
      document.querySelector("#errorAlert").style.display = "none";
      console.log("changeitAdminStatus item --> ", item);
      this.showLoader = true;
      let req = {
        user_id: item.user_id,
        updated_by: sessionStorage.getItem("jwt"),
        email: item.email,
        first_name: item.first_name,
        last_name: item.last_name,
        admin: item.admin,
        active: item.active,
        role_ids: item.role_ids,
        it_admin: item.it_admin,
        mobile: item.mobile,
      };
      let config = {
        method: "post",
        url: `${this.$config.backend_url}/updateUsersData`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: req,
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          if (response.data.status == "S") {
            document.querySelector("#sucessAlert").style.display = "block";
            this.setGridData();
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else if (
            error.response &&
            error.response.status === 400 &&
            error.response.data.message ===
              "This Password is not allowed, Choose different password."
          ) {
            alert(error.response.data.message);
          } else {
            document.querySelector("#errorAlert").style.display = "block";
            console.log("axios error", error.message);
          }
        });
    },

    changeAdminStatus(item) {
      document.querySelector("#errorAlert").style.display = "none";
      this.hideWhileLoading = true;
      console.log("changeAdminStatus item --> ", item);
      this.showLoader = true;
      let req = {
        user_id: item.user_id,
        updated_by: sessionStorage.getItem("jwt"),
        email: item.email,
        first_name: item.first_name,
        last_name: item.last_name,
        admin: item.admin,
        active: item.active,
        role_ids: item.role_ids,
        it_admin: item.it_admin,
        mobile: item.mobile,
      };
      console.log("nsfhgvfguev", req);
      let config = {
        method: "post",
        url: `${this.$config.backend_url}/updateUsersData`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: req,
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          if (response.data.status == "S") {
            document.querySelector("#sucessAlert").style.display = "block";
            this.setGridData();
            this.hideWhileLoading = false;
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else if (
            error.response &&
            error.response.status === 400 &&
            error.response.data.message ===
              "This Password is not allowed, Choose different password."
          ) {
            alert(error.response.data.message);
          } else {
            document.querySelector("#errorAlert").style.display = "block";
            this.hideWhileLoading = false;
            console.log("axios error", error.message);
          }
        });
    },
    changeActiveStatus(item) {
      document.querySelector("#errorAlert").style.display = "none";
      console.log("changeActiveStatus item --> ", item);
      this.hideWhileLoading = true;

      let req = {
        user_id: item.user_id,
        updated_by: sessionStorage.getItem("jwt"),
        email: item.email,
        first_name: item.first_name,
        last_name: item.last_name,
        active: item.active,
        admin: item.admin,
        role_ids: item.role_ids,
        it_admin: item.it_admin,
        mobile: item.mobile,
      };
      this.showLoader = true;
      let config = {
        method: "post",
        url: `${this.$config.backend_url}/updateUsersData`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: req,
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          if (response.data.status == "S") {
            document.querySelector("#sucessAlert").style.display = "block";
            this.setGridData();
            this.hideWhileLoading = false;
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else if (
            error.response &&
            error.response.status === 400 &&
            error.response.data.message ===
              "This Password is not allowed, Choose different password."
          ) {
            alert(error.response.data.message);
            this.hideWhileLoading = false;
          } else if (error.response && error.response.status === 429) {
            alert(error.response.data);
            this.hideWhileLoading = false;
          } else {
            document.querySelector("#errorAlert").style.display = "block";
            console.log("axios error", error.message);
            this.hideWhileLoading = false;
          }
        });
    },
    showPassword() {
      if (this.type === "password") {
        this.type = "text";
        this.btnText = "Hide Password";
      } else {
        this.type = "password";
        this.btnText = "Show Password";
      }
    },
    addDoc() {
      this.isEdit = false;
    },
    setGridData: async function() {
      this.headersData = [
        {
          text: "User Name",
          value: "user_name",
          sortable: true,
        },
        {
          text: "First Name",
          value: "first_name",
          sortable: true,
        },
        {
          text: "Last Name",
          value: "last_name",
          sortable: true,
        },

        {
          text: "Role(s)",
          value: "userRoleNames",
          sortable: true,
        },
        {
          text: "Email",
          value: "email",
          sortable: true,
        },
        {
          text: "Phone Number",
          value: "mobile",
          sortable: true,
        },
        {
          text: "Status",
          value: "active",
          sortable: true,
        },
        {
          text: "is Admin",
          value: "admin",
          sortable: true,
        },
        {
          text: "Temporary Admin Status",
          value: "status",
          sortable: true,
        },
        { text: "Actions", value: "actions", sortable: true },
      ];
      this.showLoader = true;
      let functionCalls = [this.getUsers(), this.getRoles()];
      let responses = await Promise.all(functionCalls);
      let users = responses[0];
      let roles = responses[1];
      users.forEach((user) => {
        let userRoleNames = [];
        user.role_ids.forEach((userRole) => {
          userRoleNames.push(
            roles.find((role) => role.id === userRole).role_name
          );
        });
        user["userRoleNames"] = userRoleNames;
      });
      this.roleData = roles;
      this.usersData = users;
      this.showLoader = false;
    },
    async getUsers() {
      try {
        let config = {
          method: "get",
          url: `${this.$config.backend_url}/getUsers`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        };
        this.showLoader = true;
        this.noteLastAPICallTime();
        let response = await axios(config);
        this.showLoader = false;

        if (response.data.status === "S") {
          if ("it_admin" in response.data.data[0]) {
            let newItem = {
              text: "is IT Admin",
              value: "it_admin",
              sortable: true,
            };
            this.headersData.splice(this.headersData.length - 1, 0, newItem);
          }
          console.log("users object", response.data.data);
          return response.data.data;
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          sessionStorage.clear();
          router.push("/login");
        } else if (
          error.response &&
          error.response.status === 400 &&
          error.response.data.message ===
            "This Password is not allowed, Choose different password."
        ) {
          alert(error.response.data.message);
        } else {
          alert("internal error");
          console.log("axios error", error.message);
          return [];
        }
      }
    },
    async getRoles() {
      try {
        let config = {
          method: "get",
          url: `${this.$config.backend_url}/getRoles`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        };
        this.noteLastAPICallTime();
        this.showLoader = true;

        let response = await axios(config);
        this.showLoader = false;

        if (response.data.status === "S") {
          return response.data.data;
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          sessionStorage.clear();
          router.push("/login");
        } else if (
          error.response &&
          error.response.status === 400 &&
          error.response.data.message ===
            "This Password is not allowed, Choose different password."
        ) {
          alert(error.response.data.message);
        } else {
          alert("internal error");
          console.log("axios error", error.message);
          return [];
        }
      }
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },
    searchUserName() {
      console.log("searchUserName  --> ");

      let req = {
        user_name: this.editeditem.user_name,
      };
      this.usernameSearchInProgress = true;
      this.usernameAvailable = false;
      this.usernameNotAvailable = false;
      let config = {
        method: "post",
        url: `${this.$config.backend_url}/UserNameValidation`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: req,
      };
      this.showLoader = true;

      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;

          this.usernameSearchInProgress = false;
          if (response.data.valid === true) {
            this.usernameAvailable = true;
            this.usernameNotAvailable = false;
          } else if (response.data.valid === false) {
            this.usernameNotAvailable = true;
            this.usernameAvailable = false;
          }
        })
        .catch((error) => {
          this.showLoader = false;

          alert("internal error", error);
          this.usernameSearchInProgress = false;
        });
    },
    validatePassword() {
      let req = {
        password: this.editeditem.password,
      };
      this.passwordSearchInProgress = true;
      this.passwordAllowed = false;
      this.passwordNotAllowed = false;
      let config = {
        method: "post",
        url: `${this.$config.backend_url}/PasswordValidation`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: req,
      };
      this.showLoader = true;

      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;

          this.passwordSearchInProgress = false;
          if (response.data.valid === true) {
            this.passwordAllowed = true;
            this.passwordNotAllowed = false;
          } else if (response.data.valid === false) {
            this.passwordNotAllowed = true;
            this.passwordAllowed = false;
          }
        })
        .catch((error) => {
          this.showLoader = false;

          alert("internal error", error);
          this.passwordSearchInProgress = false;
        });
    },
    editItem(item) {
      this.isEdit = true;
      this.editeditem = { ...item };
      this.editeditem.roles = item.role_ids;
      this.editedIndex = this.usersData.indexOf(item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.isEdit = false;
      this.$nextTick(() => {
        this.editeditem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.$refs.form.reset();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      document.querySelector("#errorAlert").style.display = "none";
      this.hideWhileLoading = true;
      console.log("checking password", this.editeditem);

      if (!this.isEdit && this.usernameNotAvailable) {
        alert("Please enter a valid UserName");
        return;
      }
      // }
      // if (
      //   this.editeditem.user_name === null ||
      //   this.editeditem.user_name === ""
      // ) {
      //   alert("Please Enter User Name ");
      //   return;
      // }
      //      if (
      //   this.editeditem.first_name === null ||
      //   this.editeditem.first_name === ""
      // ) {
      //   alert("Please Enter First Name ");
      //   return;
      // }
      // if (
      //   this.editeditem.last_name === null ||
      //   this.editeditem.last_name === ""
      // ) {
      //   alert("Please Enter Last Name ");
      //   return;
      // }
      // else if (
      //   this.editeditem.password &&
      //   this.editeditem.password !== "" &&
      //   this.editeditem.password !== null &&
      //   (!this.has_minimum_length ||
      //     !this.has_number ||
      //     !this.has_lowercase ||
      //     !this.has_uppercase ||
      //     !this.has_special ||
      //     !this.equalto_username)
      // ) {
      //   console.log(
      //     "checking value",
      //     this.has_minimum_length,
      //     this.has_lowercase,
      //     this.has_special,
      //     this.equalto_username
      //   );

      //   alert("Please make sure that proper password is entered");
      //   return;
      // } else if (
      //   this.editeditem.first_name === "" ||
      //   this.editeditem.last_name === ""
      // ) {
      //   alert("Please enter First Name & Last Name");
      //   return;
      // } else if (!this.validEmail) {
      //   alert("Please enter valid email");
      //   return;
      // } else if (!this.editeditem.roles.length) {
      //   alert("Please select atleast one role");
      //   return;
      // }
      console.log("cehcking is editemd=>", this.isEdit, this.editeditem.id);
      let req = {
        user_id: this.isEdit ? this.editeditem.user_id : undefined,
        user_name: this.isEdit ? undefined : this.editeditem.user_name,
        password:
          this.editeditem.password === ""
            ? undefined
            : this.editeditem.password,
        role_ids: this.editeditem.roles,
        email: this.editeditem.email,
        first_name: this.editeditem.first_name,
        last_name: this.editeditem.last_name,
        created_by: this.isEdit ? undefined : sessionStorage.getItem("jwt"),
        updated_by: this.isEdit ? sessionStorage.getItem("jwt") : undefined,
        admin: this.isEdit ? this.editeditem.admin : "N",
        active: this.isEdit ? this.editeditem.active : "Y",
        mobile: this.editeditem.mobile,
      };
      console.log("req is", req);

      let url = this.isEdit
        ? `${this.$config.backend_url}/updateUsersData`
        : `${this.$config.backend_url}/UserDataEntry`;
      this.showLoader = true;
      let config = {
        method: "post",
        url: url,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: req,
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          if (response.data.status == "S") {
            document.querySelector("#sucessAlert").style.display = "block";
            this.setGridData();
            this.hideWhileLoading = false;
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else if (
            error.response &&
            error.response.status === 400 &&
            error.response.data.message ===
              "This Password is not allowed, Choose different password."
          ) {
            alert(error.response.data.message);
          } else if (error.response && error.response.status === 429) {
            alert(error.response.data);
          } else {
            document.querySelector("#errorAlert").style.display = "block";
            console.log("axios error", error.message);
          }
          this.hideWhileLoading = false;
        });

      this.close();
    },
  },
};
</script>
<style scoped>
.h4Style {
  color: #fe000c;
}
.has_required {
  text-decoration: line-through;
  color: #689868;
}
.h2Style {
  color: #000000;
  padding: 12px;
}
#sucessAlert {
  display: none;
}
#errorAlert {
  display: none;
}
.gridHeader {
  color: #0a47ba;
  font: bold;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
